import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import {Dialog, Typography} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CashUsers from "../../pages/CashUsers/CashUsers";
import * as React from "react";
import {css} from "@emotion/css";

const GuardianAccount = ({openModal, handleClickOpenModal, handleCloseModal, guardianInfo}) => {
    function selectUserRowClicked(rowInfo) {
        guardianInfo(rowInfo)
        handleCloseModal()
    }

    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });
    return (
        <Dialog onClose={handleCloseModal} open={openModal} aria-labelledby="customized-dialog-title"
                id="PersonalizedMediumDialog">
            <section className={css`position: sticky;
              top: 0;
              height: 100px;
              background: #FFFFFF;
              z-index: 100 `}>
                <DialogTitle onClose={handleCloseModal}>
                    انتخاب قیم حساب
                </DialogTitle>
            </section>
            <section className="d-flex flex-column mt-2" style={{padding: "0.5rem 3rem"}}>
                <CashUsers
                    isMain={false}
                    rowOnClicked={selectUserRowClicked}/>

            </section>

        </Dialog>

    )
}
export default GuardianAccount